import { mockResults } from './mock';
import React, { useEffect, useState } from 'react';
import { v4 as Uuid } from 'uuid';
import axios from "axios";

const OPENAI_API_KEY = 'sk-None-sKyPpxWqG20pfIjGfcCfT3BlbkFJt5mHZG4R2NqM6R623umA'; // Replace with your actual OpenAI API key

async function getOpenAIResponse(prompt: string): Promise<string> {
    const response = await axios.post(
        'https://api.openai.com/v1/chat/completions',
        {
            model: 'gpt-4', // Or use 'gpt-3.5-turbo' for a smaller model
            messages: [
                { role: 'system', content: 'You are a helpful assistant.' }, // System message to set the behavior of the assistant
                { role: 'user', content: prompt } // User message with the prompt
            ],
            max_tokens: 5000, // Limit the number of tokens
        },
        {
            headers: {
                'Authorization': `Bearer ${OPENAI_API_KEY}`,
            },
        }
    );

    return response.data.choices[0].message.content.trim();
}

// Example usage:

export interface IUseSendMessage {
    sendMessage: (message: string) => void;
    setMessages: React.Dispatch<React.SetStateAction<Message[]>>; 
    messages: Message[];
    loading: boolean;
    sessionId?: string;
}
interface Message {
    isResponse: boolean;
    message: string;
    time: Date;
    results?: any[];
}
interface sendMessageInput {
    user_input: string;
    session_id: string;
    user_id: string;
}


interface MessageChat {
    response_id: string;
    isResponse: boolean;
    message: string;
    time: Date;
    results?: any[];
}

interface Patent {
    id: string;
    type: string;
    publication_id: string;
    title: string;
    abstract: string;
    publication_date: string;
    www_link: string;
    owner: string;
    image: string;
    alias: string;
    inventors: string[];
    score: number;
    snippet: string | null;
    mapping: string | null;
    index: string;
}

interface ApiResponse {
    results: Patent[];
    query: string;
    latent_query: string;
}

interface Data {
    content?: Patent[];
}

// Function to fetch data from the API and assign it to `data.content`
async function fetchDataAndAssign() {
    try {
        const response = await fetch('dcvw'); // Replace with the actual API endpoint
        const apiResponse: ApiResponse = await response.json();

        const data: Data = {};
        data.content = apiResponse.results;

        // Access the content safely
        const results = data?.content as Patent[];

        console.log(results);
        // Output: Array of patents from the API
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

// Call the function


const userDataString = localStorage.getItem('user');
const userData = userDataString ? JSON.parse(userDataString) : null;
const userId = userData ? userData.user.user_id : null;


//const request = 'http://34.94.96.59:8080/infindbot/ask'
const request = 'https://us-central1-patbio.cloudfunctions.net/output2'
const RECCOMENDATION_KEY = 'product_recommendations'

export const useSendMessage = (): IUseSendMessage => {
    const [loading, setLoading] = useState(false);
    const [sessionId, setSessionId] = useState<string>()
    const [messages, setMessages] = useState<Message[]>([])
    useEffect(() => {
      setSessionId(Uuid())
    },[])

    const sendMessage =  async (message: string) => {
        if(!sessionId) return;
        setLoading(true);
        // const input: sendMessageInput = { user_input: message, session_id: sessionId, user_id:userId}
        const input: sendMessageInput = { user_input: message, session_id: sessionId, user_id: userId}
        setMessages(prev => [ ...prev,{isResponse: false, message, time: new Date(Date.now())}])
        try {
            const response = await fetch(request, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(input)
            });
            const data = await response.json()
            console.log(data)
            // setMessages(prev => [ ...prev,{isResponse: true, message, time: new Date(Date.now())}])
            console.log(data.name)
            console.log(data.message)
            if(data?.name === RECCOMENDATION_KEY) {
                try {
                    // Temp cause api is not returning results in correct format
                    // data.content=jsonData;
                    // const results = data?.content as any[];
                    // fetchDataAndAssign();
                    console.log(message)
                    const intermediate = await getOpenAIResponse('Convert this query into something searchable over PQAI'+'"'+message+'"')
                    const response = await fetch('https://api.projectpq.ai/search/102?'+'q='+ intermediate+ '&n=10&type=patent&token=542fb33d369eadc162d13b85d7c17be6'); // Replace with the actual API endpoint
                    const apiResponse: ApiResponse = await response.json();

                    const prompt_openai = 'Answer the following question ' + '"'+message + '"'+'with the following context of patents in json format' + JSON.stringify(apiResponse.results) +'Keep the response format easily readable. Summarize the response in a paragraph within 100 words. Share references to patent numbers as well'
                    const greeting = await getOpenAIResponse(prompt_openai)
                    // getOpenAIResponse('Tell me a joke').then(console.log);
            
                    const data: Data = {};
                    data.content = apiResponse.results;

                    // Access the content safely
                    const results = data?.content as Patent[];
            
                    console.log(results);                    
                    console.log('dgsdgdsgsd');
                    setMessages(prev => [ ...prev, {isResponse: true, message: greeting, time: new Date(Date.now()), results}])
                } catch(e) {
                    console.log('gsgdgsgds')
                    setMessages(prev => [ ...prev, {isResponse: true, message: 'Here are some patents found based on your query', time: new Date(Date.now()), results: [ mockResults, mockResults, mockResults, mockResults, mockResults, mockResults]}])
                }
            } else {
                console.log('else')
                setMessages(prev => [ ...prev, {isResponse: true, message: data?.content, time: new Date(Date.now())}])
            }
        
        } catch(e) {
            console.log(e);
            setMessages(prev => [ ...prev, {isResponse: true, message: 'Patbio api failed', time: new Date(Date.now())}])
        } finally {
            setLoading(false)
        }
    }
    return { sendMessage,setMessages, loading: loading && !!sessionId, messages, sessionId  }
}